<template>
	<DsNavService
		:items="vm.baseViewModel.items"
		:aria-label="vm.baseViewModel.ariaLabel"
	>
		<slot />
	</DsNavService>
</template>
<script setup lang="ts">
import { DsNavService } from "@coloplast/design-system";
import type { GlobalServiceNavProps } from "./GlobalServiceNav.types";

defineProps<GlobalServiceNavProps>();
</script>
